import { MutationTree } from 'vuex';
import { ListsState } from './types';

export const mutations: MutationTree<ListsState> = {
};